import * as React from 'react'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import classNames from 'classnames'
import Page from 'src/shared/Page/Page'
import {RootState} from 'src/core/redux/reducer'
import {updatePassword} from 'src/core/redux/action/accountInfosAction'
import {connect} from 'react-redux'
import { Theme, createStyles, WithStyles, Typography, withStyles, Grid } from '@material-ui/core'
import { config } from 'src/conf/config'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import PageTitle from 'src/shared/PageTitle/PageTitle'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import './Contact.css'
import Swiper, { Navigation } from "swiper";

const styles = (t: Theme) => createStyles({
    imgContact: {
      margin: '1rem auto',
      display: 'block',
      maxWidth: '100%',
      height: 'auto'
    },
    contactCard: {
      textAlign: "center",
      padding: 50,
    },
    href: {
      fontWeight: "bold",
      paddingBottom: t.spacing.unit,
      textDecoration: "none",
      color: "black",
      fontSize:"0.75rem"
    },
    phone: {
      color: t.palette.grey[600],
      paddingBottom: t.spacing.unit
    },
    message: {
      paddingTop: t.spacing.unit*2,
      colot: t.palette.grey[600]
    },
    title: {
      paddingTop: t.spacing.unit*4,
      paddingBottom: t.spacing.unit*4
    },
    cityBigScreen: {
      [t.breakpoints.down('xs')]: {
        display: "none"
      }
    },
    citySmallScreen: {
      [t.breakpoints.up('sm')]: {
        display: "none"
      }
    },
    cardContainer: {
      justifyContent: "center"
    }
})

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>{
  history?: any;
}

interface ContactList {
  city: string
  phone: string
  email: string
  href: string
}

const contactList: ContactList[] = [
  {city: "BORDEAUX",   phone: "05 57 26 65 99 *", email: "sdm.bordeaux@arkea.com",  href: "https://goo.gl/maps/3aY2y8iZpGXcMxN99" },
  {city: "BREST",      phone: "02 98 28 49 50 *", email: "sdm.brest@arkea.com",     href: "https://goo.gl/maps/HAAgpgcZXXmwBBV78" },
  {city: "LYON",       phone: "04 72 56 06 69 *", email: "sdm.lyon@arkea.com",      href: "https://goo.gl/maps/qv5dGgMvn4kkGPUi8" },
  {city: "MARSEILLE",  phone: "04 96 20 38 80 *", email: "sdm.marseille@arkea.com", href: "https://goo.gl/maps/yePNrxGNheR8kjJ88" },
  {city: "NANTES",     phone: "02 40 35 00 20 *", email: "sdm.nantes@arkea.com",    href: "https://goo.gl/maps/DgCdS39s5E6STNso6" },
  {city: "PARIS",      phone: "01 53 00 36 56 *", email: "sdm.paris@arkea.com",     href: "https://goo.gl/maps/NWdKV3EC6Cwn8tiA7" },
  {city: "RENNES",     phone: "02 99 85 85 10 *", email: "sdm.rennes@arkea.com",    href: "https://goo.gl/maps/1N3r1JdLPMkTCUJ5A" },
]

class Contact extends React.Component<IProps, any>{
  swiper: any

  componentDidMount(): void {
    Swiper.use([Navigation]);
     this.swiper = new Swiper('.swiper-container', {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      })
  }

  render(){
    const { t, classes, enterprise } = this.props;
    return (
      <>

        <HelmetMeta title={t.App_title_page_Contact}/>
        <PageTitle title={t.contact} icon="question_answer" />

        <Page width="80%">
          <Grid container>
            <Grid item md={6} xs={12}>
              <Typography variant="body2">
                <span style={{fontWeight: 'bold'}}>{t.Contact_your_sales_office} : </span>
                {enterprise.sales_branch_name ? enterprise.sales_branch_name : " - "}
              </Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography variant="body2">
                <span style={{fontWeight: 'bold'}}>{t.email} : </span>
                {enterprise.sales_branch_email ? <a href={`mailto:${enterprise.sales_branch_email}`}>{enterprise.sales_branch_email}</a> : " - "}
              </Typography>
            </Grid>
            <Grid container lg={6} md={12}>
              <Grid lg={12} md={12}>
                <Typography className={classes.title} variant="title">{t.contact_title}</Typography>
              </Grid>
              <Grid item lg={12} md={12} className={classes.cityBigScreen}>
                <Grid container spacing={32} className={classes.cardContainer}>
                  {contactList.map(contact => (
                    <Grid item className={classes.contactCard} lg={4} md={12} sm={12}>
                      <a href={contact.href} className={classes.href} target="_blank">{contact.city}</a>
                      <Typography variant="caption" className={classes.phone}>{contact.phone}</Typography>
                      <a href={`mailto:${contact.email}`}  className={classes.href} target="_blank">{contact.email}</a>
                    </Grid>
                  ))}
                  <Grid item md={12} xs={12}>
                    <Typography variant="caption" className={classes.message}>{t.contact_phone_number_message}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <div className={classNames(classes.cityBigScreen, "contanct__map-wpr")}>
              <a href="https://goo.gl/maps/3aY2y8iZpGXcMxN99" className="map__city bordeaux" target="_blank"></a>
              <a href="https://goo.gl/maps/HAAgpgcZXXmwBBV78" className="map__city brest" target="_blank"></a>
              <a href="https://goo.gl/maps/qv5dGgMvn4kkGPUi8" className="map__city lyon" target="_blank"></a>
              <a href="https://goo.gl/maps/yePNrxGNheR8kjJ88" className="map__city marseille" target="_blank"></a>
              <a href="https://goo.gl/maps/DgCdS39s5E6STNso6" className="map__city nantes" target="_blank"></a>
              <a href="https://goo.gl/maps/NWdKV3EC6Cwn8tiA7" className="map__city paris" target="_blank"></a>
              <a href="https://goo.gl/maps/1N3r1JdLPMkTCUJ5A" className="map__city rennes" target="_blank"></a>
              <img
                src={config.baseUrl + "/assets/images/site/iIllustrations/catre_france.svg"}
                className={this.props.classes.imgContact}
                alt={this.props.t.contact}
              />
            </div>
          </Grid>
          <div className={classes.citySmallScreen}>
            <div className="swiper-container">
              <div className="swiper-wrapper">
                {contactList.map(contact =>(
                  <div className="swiper-slide">
                    <div className={classes.contactCard} >
                      <a href={contact.href} className={classes.href} target="_blank">{contact.city}</a>
                        <Typography variant="caption" className={classes.href}>{contact.phone}</Typography>
                      <a href={`mailto:${contact.email}`} className={classes.href} target="_blank">{contact.email}</a>
                    </div>
                  </div>
                ))}
              </div>
              <div className='swiper-button-next'></div>
              <div className='swiper-button-prev'></div>
            </div>
          </div>
          <div className={classNames(classes.citySmallScreen,"contanct__map-wpr")}>
            <a href="https://goo.gl/maps/3aY2y8iZpGXcMxN99" className="map__city bordeaux" target="_blank"></a>
            <a href="https://goo.gl/maps/HAAgpgcZXXmwBBV78" className="map__city brest" target="_blank"></a>
            <a href="https://goo.gl/maps/qv5dGgMvn4kkGPUi8" className="map__city lyon" target="_blank"></a>
            <a href="https://goo.gl/maps/yePNrxGNheR8kjJ88" className="map__city marseille" target="_blank"></a>
            <a href="https://goo.gl/maps/DgCdS39s5E6STNso6" className="map__city nantes" target="_blank"></a>
            <a href="https://goo.gl/maps/NWdKV3EC6Cwn8tiA7" className="map__city paris" target="_blank"></a>
            <a href="https://goo.gl/maps/1N3r1JdLPMkTCUJ5A" className="map__city rennes" target="_blank"></a>
            <img
              src={config.baseUrl + "/assets/images/site/iIllustrations/catre_france.svg"}
              className={this.props.classes.imgContact}
              alt={this.props.t.contact}
            />
          </div>
        </Page>
      </>
    )
  }

}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  isFetching: state.accountInfo.isFetching,
  connectedUser: state.accountInfo.connectedUser,
});

const dispatch2props = dispatch => ({
  changePassword: (pwd) => dispatch(updatePassword(pwd))
});

export default compose(
  withI18n,
  withStyles(styles),
  connect(state2props, dispatch2props)
)(Contact);



// WEBPACK FOOTER //
// ./src/page/Consumer/Contact/Contact.tsx